module.exports = __webpack_public_path__ + "static/SNG3-9392bb11af497ec9459583547e2ee7f8.png";